import { EXTERNAL_API_BILL_SCOPES } from './bills.js';
import { EXTERNAL_API_CONTRACT_TEMPLATE_SCOPES } from './contract-templates.js';
import { EXTERNAL_API_CONTRACT_SCOPES } from './contracts.js';
import { EXTERNAL_API_CUSTOMER_SCOPES } from './customers.js';
import { EXTERNAL_API_INVOICE_SCOPES } from './invoices.js';
import { EXTERNAL_API_SERVICE_SCOPES } from './services.js';

/**
 * Combined External API scopes (WorkOS org API key allowlist) across every
 * `/v1/*` resource. Single source of truth for the WorkOS dashboard allowlist
 * and the `external-api:provision-key` script — see docs/agents/identity-decisions.md
 * § ID-024.
 *
 * All scopes here use the `external:` namespace prefix. Do not add Platform
 * RBAC slugs (e.g. `ar:read`) — those belong to `packages/types/src/permissions.ts`
 * and are a separate auth plane.
 */
export const EXTERNAL_API_SCOPES = [
  ...EXTERNAL_API_BILL_SCOPES,
  ...EXTERNAL_API_INVOICE_SCOPES,
  ...EXTERNAL_API_SERVICE_SCOPES,
  ...EXTERNAL_API_CUSTOMER_SCOPES,
  ...EXTERNAL_API_CONTRACT_SCOPES,
  ...EXTERNAL_API_CONTRACT_TEMPLATE_SCOPES,
] as const;
